import { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { auth as authApi } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('mandispot_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const me = await authApi.me();
      setUser(me);
    } catch (e) {
      console.warn('[auth] /me failed, clearing token', e?.response?.status);
      localStorage.removeItem('mandispot_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback((token, u) => {
    localStorage.setItem('mandispot_token', token);
    setUser(u);
  }, []);
  const logout = useCallback(() => {
    navigator.serviceWorker?.controller?.postMessage('clear-api-cache');
    localStorage.removeItem('mandispot_token');
    localStorage.removeItem('mandispot_khata_dashboard_v1');  // no private Khata data left on shared phones
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, logout, refresh, setUser }),
    [user, loading, login, logout, refresh],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

const BIZ_ROLES = ['super_admin', 'business_owner', 'staff', 'cse', 'technician', 'accounts'];
export const isBizStaff = (u) => !!u && (u.role === 'admin' || u.role === 'owner' || BIZ_ROLES.includes(u.business_role));
